/* Phone browsers, not a Telegram frame: one centred column that stays a phone
   column on a desktop screen too. */
.page {
  max-inline-size: 560px;
  margin-inline: auto;
  min-block-size: 100dvh;
  padding-block-end: calc(var(--space-6) + env(safe-area-inset-bottom));
}

.bar {
  position: sticky;
  inset-block-start: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: calc(var(--space-2) + env(safe-area-inset-top)) var(--space-4) var(--space-2);
  background: color-mix(in srgb, var(--bg) 88%, transparent);
  backdrop-filter: blur(12px);
  border-block-end: 1px solid var(--border);
}

.shop {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-inline-size: 0;
  font-weight: 600;
  color: var(--ink);
}

.shop > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content {
  padding-inline: var(--space-4);
}

/* Availability is never colour alone: the chip carries the word beside the dot. */
[data-availability="available"] .dot {
  background: var(--success);
}

[data-availability="reserved"] .dot {
  background: var(--warning);
}

[data-availability="sold"] .dot {
  background: var(--ink-muted);
}

.noMedia {
  display: grid;
  justify-items: center;
  gap: var(--space-2);
  font-size: var(--text-caption);
}

/* ------------------------------------------------------------ states -- */
.loading {
  display: grid;
  gap: var(--space-3);
}

.skeletonHero,
.skeletonLine {
  background: var(--tint-ink);
  border-radius: 4px;
}

.skeletonHero {
  aspect-ratio: 4 / 3;
  border-radius: 0;
  margin-block-end: var(--space-2);
}

.skeletonLine {
  block-size: 18px;
  margin-inline: var(--space-4);
}

.message {
  display: grid;
  justify-items: center;
  gap: var(--space-3);
  padding: var(--space-6) var(--space-5);
  text-align: center;
}

.messageMark {
  display: grid;
  place-items: center;
  inline-size: 72px;
  block-size: 72px;
  border-radius: var(--radius-pill);
  background: var(--tint-ink);
  color: var(--ink-muted);
}

.messageTitle {
  font-size: 1.125rem;
  font-weight: 600;
  text-wrap: balance;
}

.messageBody {
  color: var(--ink-muted);
  font-size: var(--text-body-sm);
  line-height: 1.6;
  max-inline-size: 32ch;
}

.heroOpen {
  position: absolute;
  inset: 0;
  cursor: zoom-in;
}

.heroOpen:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
}

/* Says "this opens bigger" without a word; sits on the photo, so fixed ink on
   the tag's cream reads in both themes. */
.zoomBadge {
  position: absolute;
  inset-block-end: var(--space-3);
  inset-inline-end: var(--space-3);
  display: grid;
  place-items: center;
  inline-size: 36px;
  block-size: 36px;
  border-radius: var(--radius-pill);
  color: var(--qr-ink);
  background: color-mix(in srgb, var(--qr-paper) 85%, transparent);
  box-shadow: 0 1px 4px rgb(0 0 0 / 0.18);
}

.retry {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-block-size: 44px;
  padding-inline: var(--space-4);
  border-radius: var(--radius-pill);
  border: 1px solid var(--border);
  color: var(--ink);
}
